import { Modal, Button } from "react-bootstrap";

interface ConfirmDeleteModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void
}

export function ConfirmDeleteModal({
  show,
  onCancel,
  onConfirm
}: ConfirmDeleteModalProps) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Recurring Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this recurring report?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" size="sm" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
